import { Injectable, NgZone } from '@angular/core';
import { constant } from 'app/app.constants';
import { INotificationOptions } from 'app/core/interfaces/notification-options.interface';
import { SignalRService } from 'app/core/services/signal-r.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

declare const Notification: any;

@Injectable()
export class TripNotificationsService {
  private _companyIdTodaysTrips = new BehaviorSubject<number>(null);
  public companyIdTodaysTrips$: Observable<number> =
    this._companyIdTodaysTrips.asObservable();

  private _connection = new BehaviorSubject<any>(null);
  public connecion$: Observable<any> = this._connection.asObservable();
  private connection: any;
  private tripsHubConnection = 'ActiveTrips';

  constructor(private ngZone: NgZone, private signalRService: SignalRService) { }

  closeSignalR() {
    if (this.connection) {
      this.signalRService
        .deleteHubConnection(constant.URL_HUB_ACTIVE_TRIPS)
        .toPromise();
      this.signalRService.unsubscribeTo(this.tripsHubConnection);
      this.signalRService.stop();
      this.setConnection(null);
      this.setCompanyIdTodaysTrips(null);
    }
  }

  setConnection(connection: any): void {
    this.connection = connection;
    this._connection.next(connection);
  }

  setCompanyIdTodaysTrips(companyId: number) {
    this._companyIdTodaysTrips.next(companyId);
  }

  requestPermission(): Promise<string> {
    const permissionNotification = Notification.permission;
    if (permissionNotification === 'granted') {
      return;
    }

    return new Promise((resolve, reject) => {
      if ('Notification' in window) {
        Notification.requestPermission().then((permission: string) => {
          resolve(permission);
        });
      }
    });
  }

  notify(title: string, options?: INotificationOptions): Observable<void> {
    const permissionNotification = Notification.permission;
    if (permissionNotification !== 'granted') {
      this.requestPermission();
    }

    const notification = new Notification(title, options);
    return new Observable<void>(observer => {
      notification.onclick = (event: Event) => {
        event.preventDefault();
        window.focus();
        this.ngZone.run(() => observer.next());
      };
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/trip-notifications.service.ts